import React from 'react';
import ReactDOM from 'react-dom/client'
import { App } from '@app/ahava/modules';

ReactDOM.createRoot(document.getElementById('saywhatt-page')!).render(<App />)